
import { Head } from "components/Head";
import { Breadcrumbs, MainLayout } from "components/Layout";
import { useEffect } from "react";
import newsBgImg from "assets/images/banner/skills.jpeg";
import { useGetManual } from "../api/getManual";

export const EmisManual = () => {
  const manualQuery = useGetManual();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  if (manualQuery.isLoading) {
    return <></>;
  }
  const routes = [
    {
      name: "Home",
      path: "/",
    },
  ];

  if (!manualQuery.data) return null;

  return (
    <MainLayout title="EMIS Manual">
      <Head title="EMIS Manual" />
      <div class="relative overflow-hidden h-80">
        <img
          src={newsBgImg}
          alt="EMIS Manual"
          class="object-cover w-full h-full"
        />
        <div class="absolute w-full py-10 bottom-0 inset-x-0  text-white px-24 text-xs leading-4 bg-gradient-to-t from-black">
          <h1 className="text-6xl font-bold">EMIS Manual</h1>
          <Breadcrumbs routes={routes} />
        </div>
      </div>
      <div className="mx-20 my-20">
       
      </div>
    </MainLayout>
  );
};
